import React from 'react';
import { AlertTriangleIcon, ArrowRightIcon, CheckIcon, Loader2Icon } from 'lucide-react';
interface ModalFooterProps {
  primaryLabel: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  loading?: boolean;
  secondaryLabel: string;
  onSecondary: () => void;
  /** Left-hand status text, e.g. the running total or a validation summary. */
  status?: React.ReactNode;
  errorCount?: number;
  primaryIcon?: 'check' | 'arrow';
}
export function ModalFooter({
  primaryLabel,
  onPrimary,
  primaryDisabled,
  loading,
  secondaryLabel,
  onSecondary,
  status,
  errorCount = 0,
  primaryIcon = 'check'
}: ModalFooterProps) {
  const Icon = primaryIcon === 'arrow' ? ArrowRightIcon : CheckIcon;
  return <footer className="sticky bottom-0 z-10 flex items-center justify-between gap-4 border-t border-ink-200 bg-white/95 px-6 py-3.5 backdrop-blur" data-id="element-118" data-mp="2e95a36qwy3hz">
      <div className="min-w-0 text-xs" data-id="element-119" data-mp="jtswjr0dqoc0">
        {errorCount > 0 ? <p className="flex items-center gap-1.5 font-medium text-red-600" role="alert" data-id="element-120" data-mp="jvnjtbz4isj9">
            <AlertTriangleIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-121" data-mp="fbfhe7k5ftd6" />
            {errorCount} field{errorCount > 1 ? 's' : ''} need attention
          </p> : <div className="truncate text-ink-500" data-id="element-122" data-mp="o9hlivz6j24o">{status}</div>}
      </div>
      <div className="flex shrink-0 items-center gap-2" data-id="element-123" data-mp="t1ivuccseis2">
        <button type="button" onClick={onSecondary} className="rounded-md border border-ink-200 bg-white px-4 py-2 text-sm font-semibold text-ink-700 transition hover:bg-ink-50 focus:outline-none focus:ring-4 focus:ring-ink-100" data-id="element-124" data-mp="t3c0xn7r4uxy">
          {secondaryLabel}
        </button>
        <button type="button" onClick={onPrimary} disabled={primaryDisabled || loading} className="inline-flex items-center gap-1.5 rounded-md bg-brand-600 px-4 py-2 text-sm font-semibold text-white shadow-card transition hover:bg-brand-700 focus:outline-none focus:ring-4 focus:ring-brand-200 disabled:cursor-not-allowed disabled:bg-ink-300" data-id="element-125" data-mp="1c04wjq4e67vg">
          {loading ? <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-126" data-mp="fygapaiyrd5b" /> : <Icon className="h-4 w-4" aria-hidden="true" data-id="element-127" data-mp="txfx0bj07fyb" />}
          {loading ? 'Saving…' : primaryLabel}
        </button>
      </div>
    </footer>;
}